import { useState } from 'react'
import { Input } from 'almanac-ui/TextInputField/Input'
import { Button } from 'blaze-ui/Button'
import Styles from './AddKeywordsInput.module.scss'

interface AddKeywordsInputProps {
  onAddKeyword: (keyword: string) => void
}

export const AddKeywordsInput = ({ onAddKeyword }: AddKeywordsInputProps) => {
  const [keyword, setKeyword] = useState('')
  const handleAddKeyword = () => {
    onAddKeyword(keyword)
    setKeyword('')
  }

  return (
    <div className={Styles.addMoreKeywords}>
      <Input
        className={Styles.keywordInput}
        name="Custom Keyword"
        placeholder="Add your own keyword"
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && handleAddKeyword()}
        autoComplete="off"
      />
      <Button variant="tertiary" size="md" onPress={handleAddKeyword}>
        Add
      </Button>
    </div>
  )
}
